export const COURSE_PROGRAM_CHAR_LIMIT = 50;
